import { cerrarSesion } from '@/redux/slices/usuarioSlice';
import { useAppDispatch } from './redux';
import { useCallback, useEffect } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { CREDENCIALES } from '@/routes/AppRoutes';
import Swal from 'sweetalert2';

export const tokenEstaExpirado = (t: string): boolean => {
  const tokenDecodificado = jwtDecode(t);
  const sActuales = Math.floor(Date.now() / 1000);

  return tokenDecodificado.exp < sActuales;
};

export const useRutasProtegidas = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const token = Cookies.get('t');

  const mantenerExpiracion = useCallback(async () => {
    await Swal.fire({
      title: 'Sesion expirada',
      text: 'Por favor, inicia sesion nuevamente',
      icon: 'error',

      confirmButtonColor: 'var(--bGreen-600)',
    });
    dispatch(cerrarSesion());
    navigate(CREDENCIALES.INICIARSESION, { replace: true });
  }, [dispatch, navigate]);

  useEffect(() => {
    // Si se expira el token borro la sesion y lo envio al inicio de sesion
    if (!token || tokenEstaExpirado(token)) {
      mantenerExpiracion();
    }
  }, [dispatch, token, navigate, mantenerExpiracion]);

  return { token };
};
